import { Tooltip } from "@material-ui/core"
import { Block } from "@material-ui/icons"
import React from "react"
import { format, parseISO } from "date-fns"
import DailyTimestamp from "../utils/DailyTimestamp"
import MessageDivider from "../utils/MessageDivider"
import { MessageAck } from "../utils/MessageAck"

/**
 * @typedef {Object} Contact
 * @property {string} name
 */

/**
 * @typedef {Object} DeletedWithoutPermissionMessageProps
 * @property {import("../MessageItem").Message} message
 * @property {import("@material-ui/styles").ClassNameMap} classes
 * @property {import("../MessageItem").Message} previousMessage
 * @property {string} messageClass
 * @property {boolean} [isGroup]
 * @property {boolean} [isSameDay]
 * @property {Function} [dataDescricao]
 * @property {Function} [parseISO]
 * @property {Function} [format]
 * @property {boolean} [lEhConversaInterna]
 * @property {boolean} [lUsuarioLogadoEhParticipante]
 * @property {any} [theme]
 * @property {boolean} [lMensagemDoUsuario]
 */

const DeletedWithoutPermissionMessage = React.memo(
  /**
   * @param {DeletedWithoutPermissionMessageProps} props
   */
  ({
    classes,
    message,
    previousMessage,
    messageClass,
    isGroup,
    isSameDay,
    dataDescricao,
    lEhConversaInterna,
    lUsuarioLogadoEhParticipante,
    theme,
    lMensagemDoUsuario,
  }) => {
    return (
      <React.Fragment key={message.id}>
        <DailyTimestamp
          message={message}
          previousMessage={previousMessage}
          isSameDay={isSameDay}
          parseISO={parseISO}
          dataDescricao={dataDescricao}
          classes={classes}
        />

        <MessageDivider
          message={message}
          previousMessage={previousMessage}
          classes={classes}
          lEhConversaInterna={lEhConversaInterna}
          lUsuarioLogadoEhParticipante={lUsuarioLogadoEhParticipante}
        />

        <div id={message.id} className={messageClass}>
          {isGroup && <span className={classes.messageContactName}>{message.contact?.name}</span>}

          <div className={classes.textContentItem}>
            <Tooltip
              title="Esta mensagem foi apagada por outro usuário e você não tem permissão para visualizar o conteúdo."
              placement="top"
              arrow
            >
              <span
                className={classes.textContentItemDeletedWithoutPermission}
                style={{ display: "flex", alignItems: "center" }}
              >
                <Block color="disabled" fontSize="small" className={classes.deletedIcon} />
                Sem permissão para ver mensagem apagada
              </span>
            </Tooltip>
          </div>

          <span className={classes.timestamp}>
            {format(parseISO(message.createdAt), "HH:mm")}
            <MessageAck
              ack={message.ack}
              isDeleted={true}
              fromMe={lEhConversaInterna ? lMensagemDoUsuario && lUsuarioLogadoEhParticipante : lMensagemDoUsuario}
              theme={theme}
              classes={classes}
            />
          </span>
        </div>
      </React.Fragment>
    )
  },
)

DeletedWithoutPermissionMessage.displayName = "DeletedWithoutPermissionMessage"
export default DeletedWithoutPermissionMessage
